import '../vendor/TimedPopUp.js';
import Cookies from 'js-cookie';

$(document).ready(function() {

    var $activePopupButton = jQuery('#Subscribe');
    var forceOpening = true;
    $activePopupButton.on('click', function() {
        $('[data-timed-popup]').TimedPopup(forceOpening);
    });

    $("#form-newsletter-popup").submit(function( event ) {
        var date = new Date();
        var days = 7;
        date.setTime(date.getTime() + (days*24*60*60*1000));
        Cookies.set('NEWSLETTER_POPUP', 'sent-away', { expires: date });
    });


    $("#mc-embedded-subscribe").on('click',function() {
        if(!$('input[name="newsletter_marketing"]').is(':checked')) {
            $(".checkbox-error").show();
            setTimeout(function(){
                $(".checkbox-error").hide();
            }, 5000);
        }
    });
});
